import { render, staticRenderFns } from "./CourseInfoCertification.vue?vue&type=template&id=2e36966c&"
import script from "./CourseInfoCertification.vue?vue&type=script&lang=js&"
export * from "./CourseInfoCertification.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfoCertification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports